/**
 * sesionCerradaHelper.ts — Detecta si una venta pertenece a una sesión ya cerrada.
 */

import type { CierreCaja } from "../types/caja.types";
import { txRead } from "@/lib/persistence/transactionalStore";

const CIERRES_KEY = "caja_cierres_historial";

export function readCierresHistorial(): CierreCaja[] {
  try {
    const parsed = txRead<CierreCaja[]>(CIERRES_KEY, []);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function isSesionCerrada(sesionId?: string | null): boolean {
  const sid = String(sesionId || "").trim();
  if (!sid) return false;
  return readCierresHistorial().some(
    (c) => c.sesionId === sid && c.estado === "cerrada",
  );
}

export function diasEntreFechas(desde: string, hasta: string): number {
  const a = new Date(desde).getTime();
  const b = new Date(hasta).getTime();
  if (!Number.isFinite(a) || !Number.isFinite(b)) return 0;
  return Math.max(0, Math.floor((b - a) / (24 * 3600_000)));
}
